import { Layout } from 'antd'
import { useEffect, useState } from 'react'
import HeaderBar from '../../components/portal/ManageHeader'
import ManageMain from '../../components/portal/ManageMain'
import SiderNav from '../../components/portal/SiderNav'
import { isAuthenticated } from '../../utils/session'
import { useNavigate } from "react-router-dom";

const { Sider, Header, Content } = Layout


const Index = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState();


    useEffect(() => {
        if (!isAuthenticated()) {
            navigate("/");
        }

        if (window.innerWidth < 768) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }

    }, []);

    // 设置Sider的minHeight可以使左右自适应对齐
    const theme = 'light'
    return (
        <div id='page'>
            <Layout>
                <Sider collapsible
                    trigger={null}
                    collapsed={collapsed}
                    theme={theme}
                    collapsedWidth={70}
                >
                    <SiderNav collapsed={collapsed} theme={theme} />
                </Sider>
                <Layout>
                    <Header style={{ background: '#fff', padding: '0 16px', height: '54px' }}>
                        <HeaderBar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
                    </Header>
                    <Content>
                        <ManageMain />
                    </Content>
                </Layout>
            </Layout>
        </div>
    );
}

export default Index